import React, { useEffect } from 'react';
import {
    PackageCheck,
    FileText,
    ExternalLink,
} from 'lucide-react';
import { Tooltip as MatToolTip } from "@mui/material";

const GeneratedTestScenariosTab = ({ chatId, handleOpenTab, generatedTestScenarios, getChatDetails }) => {
    useEffect(() => {
        getChatDetails(chatId);
    }, []);

    return (
        <div className="w-full flex flex-col h-full">
            <div className="w-full flex-1 overflow-y-auto px-4 py-6 chatscreen-custom-scrollbar">
                <div className="w-full space-y-6">
                    {/* Generated Test Scenarios Section */}
                    {chatId && generatedTestScenarios && generatedTestScenarios.length > 0 && (
                        <div className="bg-[var(--agent-prompt)] rounded-xl p-3">
                            {/* Header */}
                            <div className="flex items-center mb-4">
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-[var(--primary-color)]/10 rounded-lg">
                                        <PackageCheck size={20} className="text-[var(--primary-color)]" />
                                    </div>
                                    <div>
                                        <span className="text-xl font-medium text-[var(--text-primary)]">Generated Test Scenarios</span>
                                        <span className="text-sm text-[var(--text-secondary)] block">
                                            {generatedTestScenarios.length} scenario{generatedTestScenarios.length !== 1 ? 's' : ''} created
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Scenarios List */}
                            <div className="space-y-2">
                                {generatedTestScenarios.map((item, index) => (
                                    <div
                                        key={index}
                                        className="group cursor-pointer transition-all duration-200 rounded-lg hover:bg-green-500/10"
                                        onClick={() => handleOpenTab({
                                            title: item.title,
                                            type: "test-scenario",
                                            id: item.id,
                                        }, "test-scenario")}
                                    >
                                        <div className="relative py-2 px-1 rounded-lg bg-[var(--hover-bg)] transition-all duration-200 hover:shadow-md">
                                            {/* Main Content */}
                                            <div className="flex items-center justify-between">
                                                {/* Left side: Icon, Title, and Description */}
                                                <div className="flex items-center flex-1 min-w-0">
                                                    {/* Count */}
                                                    <div className="flex-shrink-0 p-2 bg-gradient-to-br from-[var(--primary-color)]/10 to-[var(--primary-color)]/5 rounded-lg">
                                                        {index+1}.
                                                    </div>

                                                    {/* Text Content */}
                                                    <MatToolTip
                                                        title={
                                                            <div className="text-sm">
                                                                {item.title}
                                                            </div>
                                                        }
                                                        placement="top"
                                                        arrow
                                                    >
                                                        <div className="flex-1 min-w-0 overflow-hidden">
                                                            <span className="text-base font-medium text-[var(--text-primary)] truncate block">
                                                                {item.title}
                                                            </span>
                                                        </div>
                                                    </MatToolTip>
                                                </div>

                                                {/* Right side: Action indicators */}
                                                <div className="flex items-center gap-2 flex-shrink-0 ml-2">
                                                    {/* View icon */}
                                                    <div className="p-2 rounded-lg">
                                                        <ExternalLink size={16} className="text-[var(--text-secondary)]" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div >
    );
};

export default GeneratedTestScenariosTab;
